<template>
  <div class="cmp-wrapper">
    <basic-container>
      <basic-table></basic-table>
    </basic-container>
  </div>
</template>


<script>
import BasicTable from "./../../../blocks/mc-basic-table/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    BasicTable
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
